// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header__logo":"Header_header__logo__DRD+M"};